import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingBar from 'react-top-loading-bar';
import AppLayout from './Layout';
import { useDarkMode } from './context/DarkModeContext';
import { ConfigProvider, theme, App as AntDApp } from 'antd';
import { cleanupSocket, setupSocket, socket } from './redux/actions/socket';
import useAuth from './hooks/useAuth';
import { getTemplates } from './redux/actions/template';
import { handleNotificationPermission } from './utils/BrowserNotification';
import "flag-icons/css/flag-icons.min.css";

const App = () => {
  const { user } = useAuth();
  const { loading } = useSelector((state) => state.loadingSlice);
  const loadingBarRef = useRef(null);
  const { isDarkMode } = useDarkMode();

  useEffect(() => {
    if (loading) {
      loadingBarRef.current?.continuousStart();
    } else {
      loadingBarRef.current?.complete();
    }
  }, [loading]);

  useEffect(() => {
    if (user?.id) {
      handleNotificationPermission();
      getTemplates();

      if (!socket.connected) socket.connect();
      setupSocket(user.id);
    }

    return () => {
      if (user?.id) cleanupSocket(user.id);
    };
  }, [user?.id]);

  return (
    <div className="App">
      <ConfigProvider
        theme={{
          algorithm: isDarkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
          token: {
            colorPrimary: isDarkMode ? '0d9488' : '10b981',
            fontFamily: 'Roboto, sans-serif',
          },
        }}
      >
        <AntDApp>
          <LoadingBar color="var(--primary-color)" ref={loadingBarRef} height={3} shadow={false} />
          <Router>
            <AppLayout />
          </Router>
        </AntDApp>
        <ToastContainer />
      </ConfigProvider>
    </div>
  );
};

export default App;
